// composables/queries/staff/useStaff.ts
import { useLazyQuery } from '@vue/apollo-composable';
import type { StaffPaginator, StaffFilter } from '@/types/composition-functions';
import { GET_STAFF } from '@/graphql';

export const useStaff = ({
  autoFetch = true,
  variables,
}: {
  autoFetch?: boolean;
  variables?: Ref<{ filter?: StaffFilter; first?: number; page?: number }> | (() => { filter?: StaffFilter; first?: number; page?: number });
}) => {
  const { result, loading, load, refetch } = useLazyQuery<
    { getStaff: StaffPaginator },
    { filter?: StaffFilter; first?: number; page?: number }
  >(GET_STAFF, variables);
  if (autoFetch) load();

  const data = computed(() => result.value?.getStaff?.data || []);
  const paginatorInfo = computed(
    () => result.value?.getStaff?.paginatorInfo || null,
  ) as Ref<StaffPaginator['paginatorInfo'] | null>;

  return {
    staff: {
      data,
      paginatorInfo,
      loading,
      refetch,
    },
    load,
    refetch,
  };
};
